/**
 * Global
 **/
// Sort Functionality
function autoSelectLowestVariantByPrice() {
  const samplePrice = document.querySelector('.price')?.textContent?.trim();
  if (!samplePrice) return;

  const currencySymbolMatch = samplePrice.match(/[^0-9.,\s]+/) || [];
  const currencySymbol = currencySymbolMatch[0] || '$';

  const isEuropeanFormat = samplePrice.includes(',') && samplePrice.match(/\d+,\d{2}$/);

  function parsePrice(priceText) {
    if (isEuropeanFormat) {
      priceText = priceText.replace(/\./g, '').replace(',', '.'); 
    } else {
      priceText = priceText.replace(/,/g, ''); 
    }
    const parsed = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    return isNaN(parsed) ? Infinity : parsed;
  }

  function formatPrice(value) {
    return isEuropeanFormat
      ? `${currencySymbol}${value.toFixed(2).replace('.', ',')}`
      : `${currencySymbol}${value.toFixed(2)}`;
  }

  document.querySelectorAll('#product-grid li.grid__item').forEach((card) => {
    const variantInputs = card.querySelectorAll('input.variant');

    let lowestVariant = null;
    let lowestPrice = Infinity;

    variantInputs.forEach((input) => {
      const priceText = input.dataset.variantPrice;
      const price = parsePrice(priceText);

      if (price < lowestPrice) {
        lowestPrice = price;
        lowestVariant = input;
      }
    });

    if (lowestVariant) {
      lowestVariant.checked = true;

      const priceSpan = card.querySelector(`.price.price-${lowestVariant.dataset.productId}`);
      if (priceSpan) {
        priceSpan.textContent = formatPrice(lowestPrice);
      }

      const unitPriceSpan = card.querySelector(`.Unitprice-${lowestVariant.dataset.productId}`);
      if (unitPriceSpan && lowestVariant.dataset.unitprice) {
        unitPriceSpan.textContent = lowestVariant.dataset.unitprice;
      }

      const hiddenInput = card.querySelector(`input.selected-variant-value-${lowestVariant.dataset.productId}`);
      if (hiddenInput) {
        hiddenInput.value = lowestVariant.dataset.variantId;
      }

      const addToCartButton = card.querySelector(`.select-size-${lowestVariant.dataset.productId}`);
      if (addToCartButton) {
        addToCartButton.setAttribute('data-sku', lowestVariant.dataset.sku);
      }
    }
  });
}

if (
  window.location.search.includes('sort_by=price-ascending') ||
  window.location.search.includes('sort_by=price-descending')
) {
  autoSelectLowestVariantByPrice();
}

// ADA Changes for Menu Dropdown
document.querySelectorAll('.header__inline-menu details.header__menu-item-first-level').forEach(dropdown => {
  dropdown.addEventListener('mouseenter', () => {
    if (dropdown.getAttribute('open') === 'true') {
      const nextSummary = dropdown.querySelector('summary');
      if (nextSummary && nextSummary.tagName.toLowerCase() === 'summary') {
        nextSummary.setAttribute('aria-expanded', 'true');
      }
    }
  });
  
  dropdown.addEventListener('mouseleave', () => { 
    const nextSummary = dropdown.querySelector('summary');
    if (nextSummary && nextSummary.tagName.toLowerCase() === 'summary') {
      nextSummary.setAttribute('aria-expanded', 'false');
    }
  });
});

// Merchandise Block
function applyMerchHeight() {
  const merchHeight = document.getElementById('merchandise-block');
  const targetElements = document.querySelectorAll('.merchandise-block .banner-media');

  if (merchHeight && targetElements.length > 0) {
    const sourceHeight = merchHeight.offsetHeight;

    targetElements.forEach(el => {
      el.style.height = sourceHeight + 'px';
    });
  }
}

setTimeout(() => {
  if (
    document.getElementById('merchandise-block') &&
    document.querySelector('.merchandise-block .banner-media')
  ) {
    applyMerchHeight();
    window.addEventListener('resize', applyMerchHeight);
  }
}, 1000);

const merchBlockSwiper = document.querySelector('.merchandise-block .swiper');
if (merchBlockSwiper) {
  const slides = merchBlockSwiper.querySelectorAll('.swiper-slide');
  const slideCount = slides.length;

  const swiper = new Swiper(merchBlockSwiper, {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
      el: '.merchandise-block .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: merchBlockSwiper.querySelector('.swiper-button-next'),
      prevEl: merchBlockSwiper.querySelector('.swiper-button-prev'),
    },
    on: {
      init: function () {
        if (slideCount < 2) {
          merchBlockSwiper.querySelector('.swiper-button-prev').style.display = 'none';
          merchBlockSwiper.querySelector('.swiper-button-next').style.display = 'none';
          merchBlockSwiper.querySelector('.swiper-pagination').style.display = 'none';
        }
      }
    }
  });
}


const merchGridWrap = document.getElementById('product-grid');
const merchGrid = document.querySelectorAll('.collection .grid__item');
const merchBlock = document.getElementById('merchandise-block');

if (
  merchGridWrap &&
  merchGrid.length > 0 &&
  merchBlock &&
  merchGridWrap.dataset.columns &&
  merchGridWrap.dataset.targetRow &&
  merchGridWrap.dataset.targetCol
) {
  const itemsPerRow = parseInt(merchGridWrap.dataset.columns);
  const targetRow = parseInt(merchGridWrap.dataset.targetRow);
  const targetCol = parseInt(merchGridWrap.dataset.targetCol);

  const merchIndex = (targetRow - 1) * itemsPerRow + (targetCol - 1);

  if (merchGrid[merchIndex]) {
    merchBlock.style.display = 'block';
    merchGrid[merchIndex].parentNode.insertBefore(merchBlock, merchGrid[merchIndex]);
  }
}


// Hide Bambuser button when accessibility mode is enabled
document.addEventListener('DOMContentLoaded', function () {
  const bambuserFabContainer = document.getElementById('bambuser-fab-container');
  const showBambuserFabButton = document.getElementById('show-bambuser-fab');
  let lastFocusedElement = null;
  const getBambuserInjectedEl = () => document.querySelector('[data-bambuser-liveshopping-floating-id]');
  let accessibilityModeEnabled = localStorage.getItem('accessibilityMode') === 'true';
  let bambuserVisible = localStorage.getItem('bambuserVisible') !== 'false';

  function isVisible(el) {
    return el && el.offsetParent !== null;
  }

  function toggleBambuserFab() {
    const bambuserInjectedEl = getBambuserInjectedEl();

    if (accessibilityModeEnabled) {
      bambuserFabContainer?.style.setProperty('display', 'none');

      if (bambuserInjectedEl || isVisible(showBambuserFabButton)) {
        showBambuserFabButton?.style.setProperty('display', 'block');
        bambuserInjectedEl.style.display = 'none';
      }

      if (bambuserInjectedEl) {
        bambuserInjectedEl.classList.add('hidden-by-close');
        bambuserInjectedEl.style.display = 'none';
      }

    } else {
      bambuserFabContainer?.style.setProperty('display', 'block');
      showBambuserFabButton?.style.setProperty('display', 'none');

      if (bambuserInjectedEl && bambuserVisible) {
        bambuserInjectedEl.classList.remove('hidden-by-close');
        bambuserInjectedEl.style.display = 'inline-block';
      }
    }
  }

  function detectAccessibilityModeFromDOM() {
    const usableNetLinks = document.querySelectorAll('.UsableNetAssistive');

    for (const link of usableNetLinks) {
      const text = link.textContent.trim();
      const isVisible = link.offsetParent !== null;

      if (isVisible && text.includes('Exit Accessibility Mode')) {
        accessibilityModeEnabled = true;
        localStorage.setItem('accessibilityMode', 'true');
        break;
      } else if (isVisible && text.includes('Enable Accessibility')) {
        accessibilityModeEnabled = false;
        localStorage.setItem('accessibilityMode', 'false');
        break;
      }
    }

    toggleBambuserFab();
  }

  detectAccessibilityModeFromDOM();

  document.querySelectorAll('.UsableNetAssistive').forEach(link => {
    link.addEventListener('click', function () {
      const text = link.textContent.trim();

      if (text.includes('Enable Accessibility')) {
        accessibilityModeEnabled = true;
        localStorage.setItem('accessibilityMode', 'true');
      } else if (text.includes('Exit Accessibility Mode')) {
        accessibilityModeEnabled = false;
        localStorage.setItem('accessibilityMode', 'false');
      }
    });
  });

  const observer2 = new MutationObserver(mutations => {
    if (!accessibilityModeEnabled) return;
    for (const mutation of mutations) {
      mutation.removedNodes.forEach(removedNode => {
        if (
          removedNode.nodeType === 1 &&
          removedNode.hasAttribute('data-bambuser-liveshopping-floating-id')
        ) {
          document.body.appendChild(removedNode);
          removedNode.classList.add('hidden-by-close');
          removedNode.style.display = 'none';
          //Restore focus to button if iframe was closed
          if (lastFocusedElement) {
            setTimeout(() => lastFocusedElement.focus(), 100);
          }
          showBambuserFabButton?.style.setProperty('display', 'block');
          localStorage.setItem('bambuserVisible', 'false');
        }
      });
    }
  });

  observer2.observe(document.body, { childList: true, subtree: true });

  // Observer to detect accessibility mode toggle via DOM
  const observer = new MutationObserver(detectAccessibilityModeFromDOM);
  observer.observe(document.body, { childList: true, subtree: true });

  // Watch Live Show button click
  showBambuserFabButton?.addEventListener('click', function () {
    sessionStorage.removeItem('_bamls_dfw');
    const bambuserInjectedEl = getBambuserInjectedEl();
    if (bambuserInjectedEl) {
      bambuserInjectedEl.classList.remove('hidden-by-close');
      bambuserInjectedEl.style.display = 'inline-block';
      //set tabindex and focus on iframe wrapper
      bambuserInjectedEl.setAttribute('tabindex', '-1');
      bambuserInjectedEl.focus({ preventScroll: true });
    }
    //save the button to return focus later
    lastFocusedElement = showBambuserFabButton;

    localStorage.setItem('bambuserVisible', 'true');
    bambuserFabContainer?.style.setProperty('display', 'block');
    showBambuserFabButton?.style.setProperty('display', 'none');
  });
});

// EDP Signature Animation 
const sections = document.querySelectorAll(".section");
const headerHeight = 450;
const stickyScroll = document.querySelector('.sticky-scroll + div.section');
const fProduct = document.querySelector('.featured-product-block-wrap');
const footerH = document.querySelector('.footer');
const footerHeight = footerH.offsetHeight;
let sectionTopP = 0;

window.onscroll = () => {
  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    if (stickyScroll != undefined) {
      sectionTopP = stickyScroll.offsetTop;
    }
    const footerOffsetB = footerH.offsetTop;
    const sticky = document.querySelector('.featured-product-block-wrap .sticky-bar');
    const current = section.querySelector(".signature-animation");
    if (current != undefined) {
      if (pageYOffset >= sectionTop - headerHeight) {
        current.classList.add("animate");
        section.classList.add("active-animate");
      }
    }
    if (stickyScroll != undefined) {
      if (sticky != undefined) {
        if (pageYOffset >= sectionTopP - headerHeight) {
          sticky.classList.add("fade-in");
        } else {
          sticky.classList.remove("fade-in");
        }

        if (pageYOffset >= footerOffsetB - footerHeight) {
          sticky.classList.remove("fade-in");
        } else {
          sticky.style.bottom = '0px';
        }
      }
    }
  });

};

// Footer Newsletter Email Validation
const emailInput = document.getElementById("NewsletterForm--footer");
const message = document.getElementById("footer-block-newsletter-validemail-error");
function validateEmail(email) {
  const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return regex.test(email);
}
if (emailInput) {
  emailInput.addEventListener("input", function () {
    const emailValue = emailInput.value;
    const subscribeButton = document.getElementById('Subscribe');
    if (validateEmail(emailValue)) {
      message.style.display = "none";
      subscribeButton.disabled = false;
    } else {
      message.style.display = "flex";
      subscribeButton.disabled = true;
    }
  });
}
// variant select slider with addtocart button on PLP page
function initializeSwiperForAll() {
  var carousels = document.querySelectorAll(".swiper");
  carousels.forEach(function (carousel) {
    const swiper = new Swiper(carousel, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 10,
      speed: 200,
      loop: false,
      navigation: {
        nextEl: carousel.querySelector(".swiper-button-next"),
        prevEl: carousel.querySelector(".swiper-button-prev"),
      },
    });

  });
}
function updateCartComponents() {
  fetch(`${window.Shopify.routes.root}?sections=main-cart-items,cart-drawer,cart-icon-bubble`)
    .then((response) => response.json())
    .then((data) => {

      // Update cart page
      const cartPageContent = new DOMParser().parseFromString(data['main-cart-items'], 'text/html');
      const newCartPageContent = cartPageContent.querySelector('#main-cart-items .js-contents');
      const existingCartPageContent = document.querySelector('#main-cart-items .js-contents');
      if (existingCartPageContent && newCartPageContent) {
        existingCartPageContent.innerHTML = newCartPageContent.innerHTML;
      }

      // Update cart drawer
      const cartDrawerContent = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const newCartDrawerContent = cartDrawerContent.querySelector('#CartDrawer');
      const existingCartDrawerContent = document.querySelector('#CartDrawer');
      if (existingCartDrawerContent && newCartDrawerContent) {
        existingCartDrawerContent.innerHTML = newCartDrawerContent.innerHTML;
      }

      // Update cart icon bubble
      const cartIconBubbleContent = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
      const newCartIconBubbleContent = cartIconBubbleContent.querySelector('#cart-icon-bubble');
      const existingCartIconBubbleContent = document.querySelector('#cart-icon-bubble');
      if (existingCartIconBubbleContent && newCartIconBubbleContent) {
        existingCartIconBubbleContent.innerHTML = newCartIconBubbleContent.innerHTML;
      }
      // Update Total Price 
      const TotalPrice = document.querySelector("#CartDrawer .totals__subtotal-value");
      const cartTotalPrice = document.querySelector("#main-cart-footer .totals__subtotal-value");

      if (TotalPrice && cartTotalPrice) {
        cartTotalPrice.textContent = TotalPrice.textContent;
      }
    })
    .catch((error) => {
      console.error('Error updating cart components:', error);
    });
}
function updateCartDrawer() {
  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then((response) => response.json())
    .then((data) => {
      const cartDrawerHTML = data["cart-drawer"];

      if (cartDrawerHTML) {
        const parser = new DOMParser();
        const html = parser.parseFromString(cartDrawerHTML, "text/html");
        const cartDrawerContent = html.querySelector("#CartDrawer");
        const itemCountElement = html.querySelector(".drawer__header-right");
        if (itemCountElement) {
          const itemCount = parseInt(itemCountElement.textContent.trim(), 10);
          // Update the cart icon count
          const cartIconBubble = document.querySelector(
            "#cart-icon-bubble .header__icon-bubble span"
          );
          if (cartIconBubble && !isNaN(itemCount)) {
            cartIconBubble.textContent = itemCount;
          }
        }

        if (cartDrawerContent) {
          const existingCartDrawer = document.querySelector("#CartDrawer");
          const cartDrawerParent = document.querySelector("cart-drawer");

          if (existingCartDrawer) {
            existingCartDrawer.innerHTML = cartDrawerContent.innerHTML;
          }
          if (cartDrawerParent) {
            cartDrawerParent.classList.add("active");
            cartDrawerParent.classList.remove("is-empty");
            calculateHeaderHeight();
            document.documentElement.style.overflow = "hidden";
          }
        }
        VatModalopen();
      }
      if (window.location.pathname === "/cart") {
        updateCartComponents();
      }
    })
    .catch((error) => {
      console.error("Error updating cart drawer:", error);
    });
}
function addToCart(productId, variantId) {
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then(() => {
      updateCartDrawer();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
function quickAddButton() {
  document
    .querySelectorAll(".card__content fieldset input.variant")
    .forEach((cardRadioButton) => {
      cardRadioButton.addEventListener("change", (event) => {
        if (event.target.type === "radio") {
          const productId = event.currentTarget.dataset.productId;
          const variantId = event.currentTarget.dataset.variantId;
          const sku = event.currentTarget.dataset.sku;
          let variantPrice = event.currentTarget.dataset.variantPrice;
          if (variantPrice.includes('ש')) {
            variantPrice = variantPrice.replace('ש', 'ש"ח')
          }
          const salePrice = event.currentTarget.getAttribute("data-variant-strike-price");
          let unitPrice = event.currentTarget.getAttribute("data-unitprice");
          if (unitPrice && unitPrice.includes("ש")) {
            unitPrice = unitPrice.replace("ש", 'ש"ח');
          }
          const variantTitle = event.currentTarget.value;
          const variantImage = event.currentTarget.dataset.variantImage;

          const priceClassSelector =
            ".card__content .product-form__buttons .price-" + productId;
          const updatedPriceElement =
            document.querySelector(priceClassSelector);
          if (updatedPriceElement) {
            updatedPriceElement.innerText = variantPrice;
          }
          document.querySelector(
            ".card__content  .price-" + productId
          ).innerText = variantPrice;
          document.querySelector(".selected-variant-value-" + productId).value =
            variantId;
          document.querySelector(".sku-" + productId).dataset.sku = sku;

          const UnitSelector = ".card__content  .Unitprice-" + productId;
          const UnitPriceElement = document.querySelector(UnitSelector);
          if (UnitPriceElement) {
            UnitPriceElement.innerText = unitPrice;
          }

          const strikePrice = ".card__content  .strike-price-" + productId;
          const strikePriceElement = document.querySelector(strikePrice);
          if (strikePriceElement) {
            strikePriceElement.innerText = salePrice;
          }

          const SalePrice = ".card__content  .sale-price-" + productId;
          const salePriceElement = document.querySelector(SalePrice);
          if (salePriceElement) {
            salePriceElement.innerText = variantPrice;
          }

          const VolumeSelector =
            ".grid__item .card__heading .update_volume-" + productId;
          const VoluPriceElement = document.querySelector(VolumeSelector);
          if (VoluPriceElement) {
            VoluPriceElement.innerText = variantTitle;
          }
          const productImageElement = document.querySelector(
            ".card__media img[data-product-id='" + productId + "']"
          );
          if (productImageElement && variantImage) {
            productImageElement.src = variantImage;
            productImageElement.srcset = `${variantImage} 360w, ${variantImage} 720w, ${variantImage} 1066w`;
          }

        }
      });
    });

  document
    .querySelectorAll(".product-form__buttons button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {

        const productId = event.currentTarget.dataset.productId;
        const selectSizeButton = document.querySelector(
          ".select-size-" + productId
        );

        // Check if the product requires size selection
        if (selectSizeButton) {
          if (selectSizeButton.classList.contains("ready-to-add")) {
            const variantId = document.querySelector(
              ".selected-variant-value-" + productId
            ).value;
            addToCart(productId, variantId);
          } else {
            console.log("Please select a size before adding to cart.");
          }
        } else {
          // Direct "Add to Cart" for stores without "Select Size" button
          const variantId = document.querySelector(
            ".selected-variant-value-" + productId
          ).value;
          addToCart(productId, variantId);
        }
      });
    });

  document.querySelectorAll("button.select-size").forEach((button) => {
    button.addEventListener("click", (event) => {
      const productId = event.currentTarget.dataset.productId;
      const addToCartElement = document.querySelector(
        ".add-to-cart-" + productId
      );
      if (addToCartElement) {
        const addToCartText = addToCartElement.innerText;

        // Show the variant section and update the text if the element is found
        document
          .querySelector(".variant-section-" + productId)
          .classList.remove("hidden");
        document
          .querySelector(".select-size-" + productId)
          .classList.add("ready-to-add");
        document.querySelector(".select-size-span-" + productId).innerText =
          addToCartText;

      }
    });
  });
}
function footerScroll() {
  const element = document.querySelector("#ContactFooter-error");
  if (element && element.classList.contains("newsletter-form__message")) {
    // Scroll to the bottom of the page
    window.scrollTo(0, document.body.scrollHeight);
  }
}
setTimeout(() => {
  quickAddButton();
  footerScroll();
}, "2000");

function closeCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer && cartDrawer.classList.contains("active")) {
    cartDrawer.classList.remove("active");
    document.documentElement.style.overflow = "auto";
  }
}

// Close cart drawer when pressing Escape
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeCartDrawer();
  }
});

// Close cart drawer when clicking outside
document.addEventListener("click", (event) => {
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector("#CartDrawer-Overlay");

  if (cartDrawer && overlay) {
    if (cartDrawer.classList.contains("active") && event.target === overlay) {
      closeCartDrawer();
    }
  }
});

// Product Recommendation PDP VAT Specefic setTimeout
setTimeout(() => {
  document
    .querySelectorAll(
      ".product-recommendations .product-vat-messaging--product-card a"
    )
    .forEach((vat) => {
      vat.addEventListener("click", async () => {
        document
          .querySelectorAll("#vat-modal-overlay")
          .forEach((vatOverlay) => {
            vatOverlay.classList.add("active");
          });
        document.querySelector(".vat-modal-close").focus();
        document.querySelector("body").classList.add("modal-active");
        event.preventDefault();
      });
      return false;
    });
}, "2000");

// VAT Modal
function VatModalopen() {
  document.addEventListener("click", (event) => {
    const vatLink = event.target.closest(
      ".product-vat-messaging--product-card a, .product-vat-messaging a"
    );

    if (vatLink) {
      event.preventDefault();
      document.querySelectorAll("#vat-modal-overlay").forEach((vatOverlay) => {
        vatOverlay.classList.add("active");
      });
      document.querySelector(".vat-modal-close").focus();
      document.querySelector("body").classList.add("modal-active");
    }

    // Close VAT Modal
    if (event.target.closest(".vat-modal-close")) {
      closeModal();
    }
    return false;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  VatModalopen();
  initializeSwiperForAll();
});

// code of closemodel function that's call below and above
function closeModal() {
  document.querySelectorAll("#vat-modal-overlay").forEach((vatModal) => {
    vatModal.classList.remove("active");
  });
  document.querySelector("body").classList.remove("modal-active");
}
// Event listener for ESC key to close the modal
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    // Check if ESC key is pressed
    closeModal();
  }
});
// Event listener for clicking outside the modal to close it
document.addEventListener("click", (event) => {
  const modalOverlay = document.querySelector("#vat-modal-overlay.active");
  const modalContent = document.querySelector(".modal-content");
  if (
    modalOverlay &&
    !modalContent.contains(event.target) &&
    !event.target.closest(".product-vat-messaging--product-card a")
  ) {
    closeModal();
  }
});

const load_btn = document.getElementById("load_more_btn");
if (load_btn) {
  load_btn.addEventListener("click", () => {
    setTimeout(() => {
      quickAddButton();
      VatModalopen();
      initializeSwiperForAll();
      if (
        window.location.search.includes('sort_by=price-ascending') ||
        window.location.search.includes('sort_by=price-descending')
      ) {
        autoSelectLowestVariantByPrice();
      }
    }, "3000");
  });
}

// Usable focus after cookie popup closed
setTimeout(() => {
  const usableLink = document.querySelector(".UsableNetAssistive");
  const cookieButton = document.querySelector("#onetrust-accept-btn-handler");
  const closeButton = document.querySelector(".onetrust-close-btn-handler");
  if (cookieButton != undefined) {
    cookieButton.addEventListener("click", () => usableLink.focus());
  }
  closeButton.addEventListener("click", () => usableLink.focus());
}, "5000");
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling?.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

/**
 * Is Element Visible
 * @param {DOM element} el
 * @returns Object of DOM Element Rect
 */
function isElementVisible(el) {
  const rect = el.getBoundingClientRect(),
    vWidth = window.innerWidth || document.documentElement.clientWidth,
    vHeight = window.innerHeight || document.documentElement.clientHeight,
    efp = function (x, y) {
      return document.elementFromPoint(x, y);
    };

  return {
    rect,
    isNotFullyVisible:
      rect.right < 0 ||
      rect.bottom < 0 ||
      rect.left > vWidth ||
      rect.top > vHeight,
    isFullyVisible:
      el.contains(efp(rect.left, rect.top)) ||
      el.contains(efp(rect.right, rect.top)) ||
      el.contains(efp(rect.right, rect.bottom)) ||
      el.contains(efp(rect.left, rect.bottom)),
  };
}

/**
 * Set Mobile Header Height
 * @param {DOM Element} key Element which carries CSS property
 * @param {Number} headerGroupClientHeight Client height of header
 * @param {Object} headerMenuTopRect Object of rect of element
 * @param {Number} wunderkindBannerClientHeight Client height of wunderkind banner
 * @returns Sets property for --mobile-header-height
 */
function setMobileHeaderHeight(
  key,
  headerGroupClientHeight,
  headerMenuTopRect,
  wunderkindBannerClientHeight,
  announcementBar = null
) {
  let value = 0;

  const { isFullyVisible: headerMenuTopIsFullyVisible } = headerMenuTopRect;
  const { y, height, bottom } = headerMenuTopRect.rect;

  const announcementBarHeight = announcementBar && announcementBar.clientHeight ? announcementBar.clientHeight: 0;

  if (headerMenuTopIsFullyVisible) {
    if (wunderkindBannerClientHeight) {
      value = height + headerGroupClientHeight + wunderkindBannerClientHeight;
    } else {
      value = height + headerGroupClientHeight + announcementBarHeight;
    }
  } else if (!headerMenuTopIsFullyVisible) {
    if (y * -1 !== height) {
      value = headerGroupClientHeight + bottom;
    } else {
      value = headerGroupClientHeight + announcementBarHeight;
    }
  }

  return key.style.setProperty("--mobile-header-height", `${value}px`);
}

/**
 * Calculate Header Height
 */
function calculateHeaderHeight() {
  const headerGroup = document.querySelector(".js-sticky-header");
  const headerMenuTop = document.querySelector(".js-header-menu-top");
  const wunderkindBanner = document.querySelector(".bx-align");
  const announcementBar = document.querySelector(".announcement-bar-slider");

  const {
    preEmptive: preEmptiveWunderkindBanner,
    bannerHeight: wunderkindBannerHeight,
  } = window.Corra.wunderkindBanner;

  const { clientHeight: headerGroupClientHeight } = headerGroup,
    { documentElement: root } = document;

  const headerMenuTopRect = isElementVisible(headerMenuTop);

  if (preEmptiveWunderkindBanner && wunderkindBanner === null) {
    setMobileHeaderHeight(
      root,
      headerGroupClientHeight,
      headerMenuTopRect,
      wunderkindBannerHeight,
      announcementBar
    );
  } else if (wunderkindBanner) {
    const { clientHeight: wunderkindBannerClientHeight } = wunderkindBanner;
    setMobileHeaderHeight(
      root,
      headerGroupClientHeight,
      headerMenuTopRect,
      wunderkindBannerClientHeight,
      announcementBar
    );
  } else {
    setMobileHeaderHeight(root, headerGroupClientHeight, headerMenuTopRect, 0, announcementBar);
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 1024px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  handleAccessWidgetZIndex(element, className, revertLayer) {
    try {
      if (element.classList.contains(className)) {
        const accessWidgetUi = document.querySelectorAll(
          "access-widget-ui[data-acsb=''].notranslate"
        )[1];

        if (!accessWidgetUi) return;

        const button = accessWidgetUi.shadowRoot.querySelector(
          "button[part='acsb-trigger']"
        );

        if (!button) return;

        button.style.zIndex = revertLayer ? "revert-layer" : -1;
      }
    } catch (error) {
      console.error(`Error: handleAccessWidgetZIndex: ${error}`);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    calculateHeaderHeight();

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.style.overflow = "hidden";

    this.handleAccessWidgetZIndex(
      summaryElement,
      "mobile-facets__open-wrapper",
      false
    );
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    document.documentElement.style.overflow = "auto";

    this.handleAccessWidgetZIndex(
      this.mainDetailsToggle,
      "mobile-facets__disclosure",
      true
    );
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const { target } = event;
    const button = target.closest("button");

    if (button.classList.contains("js-header-localization-button")) return;

    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    detailsElement.removeAttribute("open");
    if (detailsElement.closest("details[open]")) {
      trapFocus(
        detailsElement.closest("details[open]"),
        detailsElement.querySelector("summary")
      );
    }
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector(".shopify-section-header");
  }

  openMenuDrawer(summaryElement) {
    document.documentElement.style.overflow = "hidden";
    calculateHeaderHeight();

    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    this.header.classList.add("menu-open");
    document.body.classList.add("menu-open");

    this.mainDetailsToggle.classList.add("menu-opening");

    summaryElement.setAttribute("aria-expanded", true);
    this.parentElement.classList.add("is-open");

    trapFocus(this.mainDetailsToggle, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);

    if (!event) return;

    if (event.target.closest("header").classList.contains("is-open")) {
      document.documentElement.style.overflow = "auto";
      this.header.classList.remove("menu-open");
      document.body.classList.remove("menu-open");
      event.target.closest("header").classList.remove("is-open");
    }
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    productYotpoSubs(); // ~/assets/product-yotpo-subs.js
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia(event);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.toggleActiveVariant(event);
      this.updateVariantPricePerMl();
      setTimeout(() => {
        VatModalopen();
      }, 500);
    }
  }

  updateVariantPricePerMl() {
    const $productPricePerMl = document.getElementById("productPricePerMl");

    if (!$productPricePerMl || !window.productVariantMetafieldsById) return;

    const { search } = window.location;
    const searchVariantId = search.split("=")[1];

    $productPricePerMl.innerText = window.productVariantMetafieldsById
      .price_per_ml[searchVariantId]
      ? window.productVariantMetafieldsById.price_per_ml[searchVariantId]
      : "";
  }

  toggleActiveVariant(event) {
    const $variantButtons = document.querySelectorAll(
      `[data-product-form="${event.target.dataset.productForm}"]`
    );

    $variantButtons.forEach(($button) => {
      const buttonIsChecked = $button.classList.contains("is-checked");
      if (buttonIsChecked) $button.classList.remove("is-checked");
    });

    event.target.classList.add("is-checked");
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (variantData && Array.isArray(variantData)) {
      this.currentVariant = variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  updateMedia(event) {
    const disableUpdateMedia = document.querySelector(
      `[data-section-id="${event.target.dataset.productForm}"]`
    );

    if (
      typeof disableUpdateMedia != "undefined" &&
      disableUpdateMedia != null
    ) {
      if (disableUpdateMedia.dataset.preventImageSwap === "true") return;
    }
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );

    const querySelectors = {
      stickyAtcWrapper: ".sticky-atc-wrapper",
      variantInputVal: ".form-product-sticky-atc input[name='id']",
      atcPriceContainer: ".sticky_atc_price",
      atcUnitPriceCont: ".sticky_atc_price_ut",
      yotpoSubs: ".yotpo-selling-plans-wrapper",
      productInfoPrice: "span.price-item.price-item--regular",
    };

    const $stickyAtcWrapper = document.querySelector(
      querySelectors.stickyAtcWrapper
    );
    const $variantInputVal = document.querySelector(
      querySelectors.variantInputVal
    );
    const $atcPriceContainer = document.querySelector(
      querySelectors.atcPriceContainer
    );
    const $atcUnitPriceCont = document.querySelector(
      querySelectors.atcUnitPriceCont
    );
    const $yotpoSubs = document.querySelector(querySelectors.yotpoSubs);
    const $productInfoPrice = document.querySelector(
      querySelectors.productInfoPrice
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;

      if (typeof $yotpoSubs != "undefined" && $yotpoSubs != null) {
        setTimeout(() => {
          const updatedYotpoPrice = document.querySelector(
            ".yotpo-selected .yotpo-subscription-label-price"
          ).textContent;

          $productInfoPrice.innerHTML = updatedYotpoPrice;

          if (!$variantInputVal) return;
          $variantInputVal.setAttribute("value", input.value);

          if (!$atcPriceContainer) return;
          $atcPriceContainer.innerHTML = "| " + updatedYotpoPrice;
        }, 500);
      } else {
        input.dispatchEvent(new Event("change", { bubbles: true }));
        const currentPrice = (this.currentVariant.price / 100).toFixed(2);

        if (!$variantInputVal) return;
        $variantInputVal.setAttribute("value", input.value);

      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const yotpoSubWrapper = document.querySelector(
      ".yotpo-selling-plans-wrapper"
    );
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {

        /* Update rewards points based on the variant change on the PDP Page */
        const loyaltyPointsEl = document.getElementById('variant-loyalty-points');
        const multiplier = parseFloat(document.querySelector('.loyalty-points-callout')?.dataset.multiplier || 0);

        if (this.currentVariant && this.currentVariant.price && multiplier) {
          const priceInDollars = this.currentVariant.price / 100;
          const points = Math.round(priceInDollars * multiplier);
          if (loyaltyPointsEl) {
            loyaltyPointsEl.textContent = `${points} Points`;
          }

          const loyaltyTextEl = document.querySelector('.loyalty-points-text');
          if (loyaltyTextEl && loyaltyTextEl.innerHTML.includes('points')) {
            loyaltyTextEl.innerHTML = loyaltyTextEl.innerHTML.replace(/\d+\s+points/, `${points} Points`);
          }
        }

        if (typeof yotpoSubWrapper != "undefined" && yotpoSubWrapper != null) {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const destinations = document.querySelectorAll(
            `#price-${this.dataset.section}`
          );

          const sources = html.querySelectorAll(
            `#price-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          );

          if (sources && destinations) {
            destinations.forEach((destination, index) => {
              destination.innerHTML = sources[index].innerHTML;
            });
          }
          const yotpoSelector = {
            atcPriceContainer: ".sticky_atc_price",
            atcUnitPriceCont: ".sticky_atc_price_ut",
            productInfoPrice: "span.price-item.price-item--regular",
          };

          const $atcPriceContainer = document.querySelector(
            yotpoSelector.atcPriceContainer
          );
          const $atcUnitPriceCont = document.querySelector(
            yotpoSelector.atcUnitPriceCont
          );
          const $productInfoPrice = document.querySelector(
            yotpoSelector.productInfoPrice
          );
          let anchors = document.getElementsByClassName(
            "yotpo-radio-container"
          );
          for (let z = 0; z < anchors.length; z++) {
            let elem = anchors[z];
            elem.onclick = function () {
              setTimeout(() => {
                const updatedYotpoPrice = this.querySelector(
                  ".yotpo-subscription-label-price"
                ).textContent;
                $productInfoPrice.innerHTML = updatedYotpoPrice;
                $atcPriceContainer.innerHTML = "| " + updatedYotpoPrice;
                $atcUnitPriceCont.innerHTML = updatedYotpoPrice;
              }, 300);
            };
          }
        } else {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const destinations = document.querySelectorAll(
            `#price-${this.dataset.section}`
          );

          const sources = html.querySelectorAll(
            `#price-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          );

          if (sources && destinations) {
            destinations.forEach((destination, index) => {
              destination.innerHTML = sources[index].innerHTML
            });
          }

          const price = document.getElementById(
            `price-${this.dataset.section}`
          );

          if (price) price.classList.remove("visibility-hidden");
        }
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const currentAtcBtnState = document.querySelector(
      ".product-form__submit-atc"
    )
      ? document.querySelector(".product-form__submit-atc")
      : document.querySelector(".product-form__submit");

    const currentAtcState = document.querySelector(".sticky_atc_state");
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");

      if (text) addButtonText.textContent = text;
      currentAtcBtnState.setAttribute("disabled", "disabled");

    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
      currentAtcBtnState.removeAttribute("disabled");

    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (button !== null) {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("visibility-hidden");
    }
  }

  getVariantData() {
    if (this.querySelector('[type="application/json"]') !== null) {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
          setTimeout(() => {
            quickAddButton();
            VatModalopen();
            initializeSwiperForAll();
          }, 500);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Equal Height for Featured Collection Product Title

function setEqualHeight(e) {
  const heightElement = document.querySelectorAll('.featured-collection-list .product-card-wrapper');
  let maxHeight = 0;

  heightElement.forEach(el => {
    el.style.height = 'auto';
  });

  heightElement.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  heightElement.forEach(el => {
    el.style.height = `${maxHeight}px`;
  });
}

window.addEventListener('load', () => {
    setEqualHeight();
});

// Optional: Apply on resize

window.addEventListener('resize', () => {
  setEqualHeight();
});

const searchOverlay = document.querySelector('.header__search details');
const overlayHtml = document.querySelector('html');

searchOverlay.addEventListener('toggle', function () {
  if (searchOverlay.open) {
    overlayHtml.classList.add('overflow-hidden');
  } else {
    overlayHtml.classList.remove('overflow-hidden');
  }
});